"use client";

import { useActionState } from "react";

import { Alert, AlertDescription } from "@/components/ui/alert";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { t } from "@/lib/i18n";

import {
  requestPasswordReset,
  type ForgotPasswordState,
} from "./actions";

export function ForgotPasswordForm() {
  const [state, formAction, pending] = useActionState<
    ForgotPasswordState,
    FormData
  >(requestPasswordReset, {});

  if (state.success) {
    return (
      <div className="grid gap-3">
        <Alert>
          <AlertDescription>{state.success}</AlertDescription>
        </Alert>
        <p className="text-sm text-muted-foreground">
          Niets ontvangen? Controleer je spamfolder of{" "}
          <a
            href="/wachtwoord-vergeten"
            className="text-primary underline-offset-4 hover:underline"
          >
            probeer het opnieuw
          </a>
          .
        </p>
      </div>
    );
  }

  return (
    <form action={formAction} className="grid gap-4">
      {state.error ? (
        <Alert variant="destructive">
          <AlertDescription>{state.error}</AlertDescription>
        </Alert>
      ) : null}
      <div className="grid gap-2">
        <Label htmlFor="email">{t.auth.email}</Label>
        <Input
          id="email"
          name="email"
          type="email"
          autoComplete="email"
          autoFocus
          required
          placeholder="naam@bedrijf.nl"
        />
      </div>
      <Button type="submit" disabled={pending}>
        {pending ? t.algemeen.bezig : t.auth.herstelKnop}
      </Button>
    </form>
  );
}
